__turbopack_context__.v({
  "body": "o4Z_jW_body",
  "card": "o4Z_jW_card",
  "content": "o4Z_jW_content",
  "copy": "o4Z_jW_copy",
  "cta": "o4Z_jW_cta",
  "iconTile": "o4Z_jW_iconTile",
  "orb": "o4Z_jW_orb",
  "orbSoft": "o4Z_jW_orbSoft",
  "orbWarm": "o4Z_jW_orbWarm",
  "pill": "o4Z_jW_pill",
  "title": "o4Z_jW_title",
});
